import React, {Fragment} from 'react';

const sidebarComponent = props => {
  return (
      <Fragment>
        <div className="col l12 m12 s12 sort-info sidebar-item">
          <div className="row">
            <div className="col m12 s12 l3 icon">
              <i className="fa fa-user"/>
            </div>
            <div className="col m12 s12 l9 info wow fadeIn a1" data-wow-delay="0.1s">
              <div className="section-item-details">
                <p>Nick Chiafullo has more than 10 years’ experience building mobile, tablet, and responsive web
                  applications and products. Nick is a full stack developer and is well versed in both front and
                  back end engineering with an in-depth expertise in all aspects of the business
                  application lifecycle.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col l12 m12 s12  mobile sidebar-item">
          <div className="row">
            <div className="col m12 s12 l3 icon">
              <i className="fa fa-phone"/>
            </div>
            <div className="col m12 s12 l9 info wow fadeIn a2" data-wow-delay="0.2s">
              <div className="section-item-details">
                <div className="personal">
                  <h4><a href="tel:732-233-1566">(732)-233-1566</a></h4>
                  <span>mobile / text</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col l12 m12 s12  email sidebar-item ">
          <div className="row">
            <div className="col m12 s12 l3 icon">
              <i className="fa fa-envelope"/>
            </div>
            <div className="col m12 s12 l9 info wow fadeIn a3" data-wow-delay="0.3s">
              <div className="section-item-details">
                <div className="personal">
                  <h4><a href="mailto:nick.chiafullo@gmail.com">nick.chiafullo@gmail.com</a></h4>
                  <span>personal</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col l12 m12 s12  address sidebar-item ">
          <div className="row">
            <div className="col l3 m12  s12 icon">
              <i className="fa fa-home"/>
            </div>
            <div className="col m12 s12 l9 info wow fadeIn a4" data-wow-delay="0.4s">
              <div className="section-item-details">
                <div className="address-details">
                  <h4>
                    Cherry Hill, NJ 08003
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col l12 m12 s12  skills sidebar-item">
          <div className="row">
            <div className="col m12 l3 s12 icon">
              <i className="fa fa-calendar-o"/>
            </div>
            <div className="col m12 l9 s12 skill-line a5 wow fadeIn" data-wow-delay="0.5s">
              <h3>Professional Skills </h3>
              <span>JavaScript (REACT / ANGULAR)</span>
              <div className="progress">
                <div className="determinate"> 95%</div>
              </div>
              <span>.NET C# MVC</span>
              <div className="progress">
                <div className="determinate"> 95%</div>
              </div>
              <span>Node</span>
              <div className="progress">
                <div className="determinate">90%</div>
              </div>
              <span>SQL / NoSQL</span>
              <div className="progress">
                <div className="determinate">80%</div>
              </div>
              <span>DOCKER / AWS / DEV OPS</span>
              <div className="progress">
                <div className="determinate">80%</div>
              </div>
              <span>PHP</span>
              <div className="progress">
                <div className="determinate">75%</div>
              </div>
              <span>JAVA</span>
              <div className="progress">
                <div className="determinate">40%</div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
  )
};

export default sidebarComponent;